import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: "website" | "article";
  schemaData?: Record<string, unknown>;
  publishedTime?: string;
  modifiedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl = "https://911chigua.com",
  ogImage = "https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20website%20branding%20with%20bold%20typography%2C%20dark%20warm%20tones%2C%20cinematic%20atmosphere%2C%20mysterious%20vibe%2C%20editorial%20design%20aesthetic&width=1200&height=630&seq=og-default-01&orientation=landscape",
  ogType = "website",
  schemaData,
  publishedTime,
  modifiedTime,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", ogType, true);
    setMeta("og:url", canonicalUrl, true);
    setMeta("og:image", ogImage, true);
    setMeta("og:site_name", "911吃瓜网", true);
    setMeta("og:locale", "zh_CN", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);
    setMeta("robots", "index, follow");

    let canonical = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    if (publishedTime) {
      setMeta("article:published_time", publishedTime);
    }
    if (modifiedTime) {
      setMeta("article:modified_time", modifiedTime);
    }

    const existingScripts = document.querySelectorAll("script[type='application/ld+json']");
    existingScripts.forEach((s) => s.remove());

    if (schemaData) {
      const dataArray = Array.isArray(schemaData) ? schemaData : [schemaData];
      dataArray.forEach((data) => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.textContent = JSON.stringify(data);
        document.head.appendChild(script);
      });
    }
  }, [
    title,
    description,
    keywords,
    canonicalUrl,
    ogImage,
    ogType,
    schemaData,
    publishedTime,
    modifiedTime,
  ]);

  return null;
}